import token, { tokenToVars } from '../token';
import Modal from './modal';

export { Modal };
export default tokenToVars(Modal, token);
